import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Archive = ({
  height = 22,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 22" {...props}>
    <path
      d="M20 8V16.25C20 17.8083 18.9333 19 17.5385 19H6.46154C5.06667 19 4 17.8083 4 16.25V8"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8 4H4.2C3.56 4 3 4.56 3 5.2V7.6H21V5.2C21 4.56 20.52 4 19.8 4Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.44 12.2C14.44 12.84 13.88 13.4 13.24 13.4H10.84C10.2 13.4 9.64001 12.84 9.64001 12.2C9.64001 11.56 10.2 11 10.84 11H13.24C13.88 11 14.44 11.56 14.44 12.2Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
